import { goToNews } from '@/app/routing/events'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'

export const XboxIntegrationNews = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const bgUrl =
    userLang === 'ru'
      ? 'https://storage.googleapis.com/gamed-games-bucket/pictures/news/ru/xbox_banner.webp'
      : 'https://storage.googleapis.com/gamed-games-bucket/pictures/news/en/xbox_banner.webp'

  return (
    <div
      className={classes.root}
      onClick={() => goToNews({ variant: 'xbox' })}
      style={{ backgroundImage: `url(${bgUrl})` }}
    />
  )
}
